import { getSizeInPx } from '../../stylesheet';
import { SvgIcon } from './SvgIcon';
import { IconProps } from './types';

export const ReportIcon = ({ widthInPx, heightInPx, color: _color }: IconProps): JSX.Element => (
  <SvgIcon
    viewBox="0 0 18 20"
    style={{
      width: getSizeInPx(widthInPx ?? 18),
      height: getSizeInPx(heightInPx ?? 20),
    }}
  >
    <path
      d="M13 3h-6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V7l-5-4Zm1 0v4h4c-1.333-1.333-2.667-2.667-4-4ZM8 11h8v2H8v-2Zm0 4h6v2H8v-2Z"
      fill="none"
      stroke="currentColor"
    />
  </SvgIcon>
);
